var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.loader},[_c('div',{class:_vm.$style.spinner},[_c('LoadingSpinner',{attrs:{"size":60}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }